module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-non-bodymatter element-type-dedication element-without-heading",
    attrs: {
      "id": "dedication"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "dedication-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width dedication-content"
  }, [_c('i', [_vm._v("For U.S. Army veteran Chris Andersen and his father, Mike, who operate C & T Auto Care at 1260 Plaza Circle, Singer Island, Riviera Beach, Florida. Gentlemen, thank you for taking such good care of my cars over the years.Chris and Mike are honest professional mechanics and have always treated me fairly. My female readers know how difficult it is for a woman to find a trustworthy mechanic.Ladies, Chris and Mike are honorable men who will maintain your vehicles at reasonable prices with the added bonus that they’re easy on the eyes.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 69
// module chunks = 0